import { Parser } from 'expr-eval';
const parser = new Parser({
    operators: {
        add: true,
        divide: true,
        multiply: true,
        subtract: true,
        remainder: true,
        logical: true,
        comparison: true,
        conditional: true,
        abs: true,
        floor: true,
        round: true,
        ceil: true,
        concatenate: false,
        factorial: false,
        power: false,
        sin: false,
        cos: false,
        tan: false,
        asin: false,
        acos: false,
        atan: false,
        sinh: false,
        cosh: false,
        tanh: false,
        asinh: false,
        acosh: false,
        atanh: false,
        sqrt: false,
        log: false,
        ln: false,
        lg: false,
        log10: false,
        trunc: false,
        exp: false,
        length: false,
        in: false,
    },
    allowMemberAccess: true,
});
const maximum = 1024 * 2;
function parse(condition) {
    const { length } = condition;
    if (length > maximum) {
        throw new RangeError(`Length of conditional (${length}) needs to be in range [0, ${maximum}]`);
    }
    try {
        const expression = parser.parse(condition);
        expression.condition = condition;
        return expression;
    }
    catch (_a) {
        throw new TypeError(`Failed to parse the conditional '${condition}'`);
    }
}
function clean(context) {
    const parsed = {};
    for (const [key, value] of Object.entries(context)) {
        if (typeof value === 'number' && !isNaN(value)) {
            parsed[key] = value;
        }
        else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            parsed[key] = clean(value);
        }
    }
    return parsed;
}
function process(expression, context) {
    const cleaned = clean(context);
    try {
        return expression.evaluate(cleaned);
    }
    catch (_a) {
        throw new RangeError(`There were unbound variables '${expression.condition}': ${JSON.stringify(cleaned)}`);
    }
}
export function evaluate(condition, context) {
    const expression = parse(condition);
    const variables = expression.variables({ withMembers: true });
    const result = process(expression, context);
    return { result, variables };
}
export default evaluate;
//# sourceMappingURL=evaluate.js.map